import React from 'react';
import { Redirect } from 'wouter';

import Route from '../common/components/Route';
import Clients from '../clients/table/Clients';
import Client from '../clients/detail/Client';
import Children from '../children/table/Children';
import Startpage from '../common/components/Startpage';
import Settings from '../settings/Settings';
import Transfers from '../transfer/table/Transfers';
import Transfer from '../transfer/detail/Transfer';
import Child from '../children/detail/Child';

function FhfRoutes() {
  return (
    <>
      <Route path='/startpage' renderComponent={() => <Startpage />} />
      <Route path='/authentication' renderComponent={() => <Redirect to='/startpage' />} />
      <Route path='/' renderComponent={() => <Redirect to='/clients' />} />

      <Route path='/transfer' renderComponent={() => <Transfers />} />
      <Route path='/transfer/:transferId' renderComponent={(params) => <Transfer transferId={params.transferId} />} />
      <Route path='/clients' renderComponent={() => <Clients />} />
      <Route path='/clients/:clientId' renderComponent={(params) => <Client clientId={params.clientId} />} />
      <Route path='/children' renderComponent={() => <Children />} />
      <Route path='/children/:childId' renderComponent={(params) => <Child childId={params.childId} />} />
      <Route path='/settings' renderComponent={() => <Settings />} />
    </>
  );
}

export default FhfRoutes;
